export const AREA_ERROR = 'AREA_ERROR';
export const AREA_REQUEST = 'AREA_REQUEST';
export const AREA_SUCCESS = 'AREA_SUCCESS';
